import { graphqlRequestBaseQuery } from '@rtk-query/graphql-request-base-query'
import { createApi } from "@reduxjs/toolkit/query/react";
import { api as endpoints } from './generated'
import {
  PATIENT_AUTH_REDUCER_KEY,
  type RootStateWithPatientAuth,
} from '../../patientAuth/patientAuthSlice'
import { CustomErrorResponse } from '../..'

export const configExternalApi = createApi({
    reducerPath: 'configApiExternal',
    tagTypes: ['config'],
    endpoints,
    keepUnusedDataFor: 14400, // 4 hours this api will rarely be updated, also recommended to include with redux persist,
    baseQuery: graphqlRequestBaseQuery<CustomErrorResponse>({
        url: `https://${process.env.CONFIG_API_DOMAIN}/graphql`,
        prepareHeaders: (headers, { getState }) => {
            const accessToken = (getState() as RootStateWithPatientAuth)[
                PATIENT_AUTH_REDUCER_KEY
            ].session?.access_token
            
            if (accessToken) {
                headers.set('Authorization', `Bearer ${accessToken}`)
            }

            return headers
        },
        customErrors: ({ message, stack, name, response }) => ({
            message,
            stack: stack || '',
            name,
            response,
        }),
    }),
})

export type ConfigExternalApiType = typeof configExternalApi
